import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { Link, useParams } from 'react-router-dom';
import { strings } from '/imports/strings';
import { Checkbox } from '/imports/ui/Checkbox';
import { ModelFormPage } from '/imports/ui/ModelFormPage';
import { Button } from '/imports/ui/Button';
import { Page } from '/imports/ui/Page';
import { generateSolarBillPdf, modelClass, SolarBill } from '/imports/api/solarBills';
import { NumberInput } from '/imports/ui/NumberInput';
import { DateInput } from '/imports/ui/DateInput';
import { toastOnError } from '/imports/ui/utils';
import { Loading } from '/imports/ui/Loading';
import { fileHref } from '/imports/api/files';

const SolarBillPageStyled = styled(Page)`
`;

/** Superuser form for editing a solar bill and generating/viewing its PDF. */
export const SolarBillPage = () => {
  const { _id } = useParams<any>();
  const defaultUpdate: Partial<SolarBill> = { _id, active: true };
  const [update, setUpdate] = useState<Partial<SolarBill>>(defaultUpdate);
  const documentRef = useRef<SolarBill>(undefined);
  const doc = documentRef.current;
  const [generatingPdf, setGeneratingPdf] = useState(false);
  /** Generates the bill PDF then reloads to show it. */
  const generatePdf = toastOnError(async () => {
    setGeneratingPdf(true);
    _id && await generateSolarBillPdf.call(_id);
    setGeneratingPdf(false);
    window.location.reload();
  });
  return <ModelFormPage
    modelClass={modelClass}
    styled={SolarBillPageStyled}
    permission={(user) => user?.isSuperUser}
    documentRef={documentRef}
    defaultUpdate={defaultUpdate}
    update={update}
    setUpdate={setUpdate}
    formSpec={[
      [{ field: 'active', input: { type: Checkbox } }],
      [{ field: 'startDate', input: { type: DateInput } }, { field: 'endDate', input: { type: DateInput } }],
      [{ field: 'issuedDate', input: { type: DateInput } }, { field: 'dueDate', input: { type: DateInput } }],
      [{ field: 'production', input: { type: NumberInput } }, { field: 'ppaRate', input: { type: NumberInput } }],
      [{ field: 'ppaCharges', input: { type: NumberInput } }, { field: 'fixedCharges', input: { type: NumberInput } }],
      [{ field: 'previousCharges', input: { type: NumberInput } }, { field: 'lateCharges', input: { type: NumberInput } }],
      [{ field: 'credits', input: { type: NumberInput } }, { field: 'accountNumber' }, { field: 'customerName' }],
    ]}
    extraButtons={
      <>
        {
          doc?.pdf?.url ?
            <Link to={fileHref(doc?.pdf) || '#'} target="_blank"><Button>{strings.ViewBill()}</Button></Link>
            :
            <Button onClick={() => generatePdf()}>{generatingPdf ? <Loading /> : strings.GeneratePdf()}</Button>
        }
      </>
    }
  />;
};